import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ColumnFiltersState, PaginationState, SortingState } from '@tanstack/react-table';
import { snakeCase } from 'lodash';

import { Configuration, GetRestrictionsRequest, RestrictionApi } from '../_openapi/portfolio-optimizer';
import { processFilter } from '../widgets/filters/filterUtils';
import { defaultApiConfig } from './defaultApiConfig';

const restrictionApi = new RestrictionApi(new Configuration(defaultApiConfig));

export const useRestrictions = ({
    pagination,
    sorting,
    columnFilters,
}: {
    pagination?: PaginationState;
    sorting?: SortingState;
    columnFilters?: ColumnFiltersState;
}) =>
    useQuery({
        queryKey: ['restrictions', 'list', { pagination, sorting, columnFilters }],
        queryFn: () => {
            const query: GetRestrictionsRequest = {};

            if (pagination) {
                query.pageIndex = pagination.pageIndex;
                query.pageSize = pagination.pageSize;
            }

            if (sorting?.length) {
                query.sortLabel = snakeCase(sorting[0].id);
                query.sortDesc = sorting[0].desc;
            }

            if (columnFilters?.length) {
                query.filter = columnFilters.map(processFilter);
            }

            return restrictionApi.getRestrictions(query);
        },
        placeholderData: keepPreviousData,
    });
